<template>
  <div :class="$style.container">
    <MobileIconButton :class="$style.closeBtn"
                      :to="{ name: 'mobile-main' }"
                      symbol="close-icon-white"
                      icon-size="16"/>

    <div :class="$style.content">
      <div :class="$style.contentCenter">
        <h2 :class="$style.mainTitle">Order Submitted!</h2>

        <svg v-svg
             :class="$style.checkmark"
             symbol="checkmark-big"
             size="119" />

        <h3 :class="$style.orderNumber">
          {{ orderInfo.number }}
        </h3>

        <p :class="$style.pickupMethod">{{ orderType }}</p>

        <hr :class="$style.delimiter">

        <div :class="$style.orderInfo">
          <p :class="$style.orderInfoText">
            <svg v-svg
                 :class="$style.infoIcon"
                 symbol="account-icon"
                 size="18" />
            {{ order.recipientName }} {{ order.phone }}
          </p>
          <p :class="$style.orderInfoText">
            <svg v-svg
                 :class="$style.infoIcon"
                 symbol="pin-white"
                 size="17 21" />
            {{ restaurant.address }}
          </p>
          <p :class="$style.orderInfoText">
            <svg v-svg
                 :class="$style.infoIcon"
                 symbol="calendar-white"
                 size="17 19" />
            {{ orderTime }}
          </p>

          <div :class="$style.bottomContent">
            <p>Upon arrival, please call our store to notify us!</p>
            <MobileButton :class="$style.callBtn"
                          :href="'tel:' + restaurant.phone"
                          btn-style="round-big">
              Call Store
            </MobileButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileContainer from '@/apps/mobile/components/MobileContainer';
import MobileHeader from '@/apps/mobile/components/MobileHeader';
import MobileIconButton from '@/apps/mobile/components/MobileIconButton';
import CheckoutPayment from '@/components/CheckoutPayment';
import { Getter, Action } from 'vuex-class';
import MobileButton from '@/apps/mobile/components/MobileButton';
import moment from 'moment';
import { ORDER_RESET, CART_RESET } from '@/apps/cart/store/types';

/**
 * Mobile order confirm.
 */
@Component({
  components: {
    MobileButton,
    MobileIconButton,
    MobileHeader,
    MobileContainer,
    CheckoutPayment,
  },
})
export default class MobileOrderConfirmation extends Vue {
  @Action(ORDER_RESET) orderReset;
  @Action(CART_RESET) cartReset;
  @Getter order;
  @Getter restByKey;

  get restaurant() {
    return this.restByKey(this.order.restaurantId);
  }

  get orderInfo() {
    return {
      number: this.order.checkId,
      type:   this.orderType,
    };
  }
  get orderTime() {
    return moment.parseZone(this.order.pickupTime).format('MM/DD/YY h:mm A');
  }

  get orderType() {
    return this.order.pickupType === 'in_store' ? 'In Store Pickup' : 'Curbside Pickup';
  }

  destroyed() {
    this.cartReset();
    this.orderReset();
  }
}
</script>

<style lang="scss" module>
@import '~@/style/variables.scss';
@import '~@/style/helpers.scss';

div.container {
  height: 100%;
  background-color: $mobile-dark-bg;
  color: $white;
  @include background-2x(
    '/assets/img/mobile-confirmation-bg',
    'jpg',
    auto, auto,
    center, center);
  background-size: cover;
}

.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 80px 0 0;
}

.bottomContent {
  margin-top: 44px;

  p {
    color: $white;
    font-family: $main-font-family;
    font-size: rem(12px);
    font-style: italic;
    font-weight: 300;
    text-align: center;
  }
}

.callBtn {
  margin: 15px auto;
}

.mainTitle {
  color: $white;
  font-family: $main-font-family;
  font-size: rem(26px);
  font-weight: bold;
  letter-spacing: rem(-0.15px);
  text-align: center;
}

.checkmark {
  display: block;
  margin: 38px auto 25px;
}

.orderNumber {
  color: $white;
  font-family: $main-font-family;
  font-weight: 700;
  font-size: rem(22px);
  text-align: center;
}

.pickupMethod {
  color: $white;
  font-family: $main-font-family;
  font-size: rem(15px);
  font-weight: 300;
  letter-spacing: rem(-0.36px);
  text-align: center;
}

.orderInfo {
  display: flex;
  flex-direction: column;
  align-items: center;

  &Text {
    color: $white;
    font-family: $main-font-family;
    font-size: rem(15px);
    font-weight: 300;
    letter-spacing: rem(-0.36px);
    text-align: center;
    display: flex;
    align-items: center;

    &+& {
      margin-top: 20px;
    }

    .infoIcon {
      margin-right: 5px;
      position: relative;
      top: -2px;
    }
  }
}

.delimiter {
  box-sizing: border-box;
  height: 4px;
  width: 115px;
  background: $green2;
  border: none;
  margin: 14px auto 40px;
}

.closeBtn {
  position: absolute;
  top: 15px;
  left: 15px;
  &:hover {
    position: absolute;
  }
}

.infoIcon {
  fill: $white;
}
</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileOrderConfirmation.vue